export default "__VITE_ASSET__DbYpKFoe__"